import { render, staticRenderFns } from "./candiDate.vue?vue&type=template&id=1bdeee60&scoped=true&"
import script from "./candiDate.vue?vue&type=script&lang=js&"
export * from "./candiDate.vue?vue&type=script&lang=js&"
import style0 from "./candiDate.vue?vue&type=style&index=0&id=1bdeee60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdeee60",
  null
  
)

export default component.exports